import ApplicationController from '../application_controller'

class UploadFileController extends ApplicationController {
  static targets = ['sendFileCopy', 'receiversGroup', 'receivers']

  connect () {
    this.sendFileCopyTarget.addEventListener('change', (e) => {
      if (e.target.checked) {
        this.receiversTarget.removeAttribute('disabled')
        this.receiversGroupTarget.classList.remove('d-none')
      } else {
        this.receiversTarget.setAttribute('disabled', true)
        this.receiversGroupTarget.classList.add('d-none')
      }
    })
  }
}

export default UploadFileController
